import React from 'react';

const TabStyles = {
    selected: {
        background: "linear-gradient(180deg, #56CCF2 0%, #2D9CDB 100%)",
        borderRadius: "3px 3px 0px 0px",
        lineHeight: "25px",
        textAlign: "center",
        fontSize:"14px",
        fontWeight: "bold",
        color: "black",
        textTransform: "uppercase"
    },
    passive:{
        background: "#F2F2F2",
        borderRadius: "3px 3px 0px 0px",
        lineHeight: "25px",
        textAlign: "center",
        fontSize:"14px",
        fontWeight: "bold",
        textTransform: "uppercase"
    }
}
export default class GameTabUI extends React.Component{
    onClick(){
        this.props.onClick(this.props.id);
    }
    render() {
        let style = this.props.isSelected ? {...TabStyles.selected} : {...TabStyles.passive};

        if (this.props.isSelected) {
            let customActiveColors = this.props.selectedStyles;
            if (customActiveColors)
                style.background = `linear-gradient(180deg, ${customActiveColors[0]} 0%, ${customActiveColors[1]} 100%)`;
        }

        return <button className="game-btn" style={{
            ...style,
            width: `${this.props.width}px`,
            height: `${this.props.height}px`
        }} onClick={this.onClick.bind(this)}>{this.props.value}</button>;
    }
}
